import React, { useEffect, useState } from "react";
import Loading from "../components/common/Loading";
import InfiniteScroll from "react-infinite-scroll-component";
import { httpReauest } from "../utils/httpRequest";
import { Shamsi } from "basic-shamsi";
import { CDN_BASE_URL } from "../config";
import CustomModal from "../components/common/Modal";
import { FaAngleDown, FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";
import { priceComma } from "../utils/priceComma";
import { BiCopy } from "react-icons/bi";
import { Link } from "react-router-dom";

const BillsPage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState();
  const [hasmore, sethasmore] = useState(true);
  const [show, setShow] = useState(false);
  const [selected, setselcted] = useState();
  const [step, setstep] = useState(1);
  const [postCode, setpostCode] = useState();

  const handleClose = () => setShow(false);
  const handleShow = (data) => {
    setselcted(data);
    setShow(true);
  };

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    setLoading(true);
    const page = products.length / 10 + 1;
    await httpReauest("GET", "/order?page=" + page + "&limit=10&payed=false", {}, {}).then(
      ({ data }) => {
        if (data?.data?.length < 10) {
          sethasmore(false);
        }
        setProducts(data.data);
      }
    );
    setLoading(false);
  }

  async function fetchData() {
    const page = products.length / 10 + 1;
    await httpReauest("GET", "/order?page=" + page + "&limit=10&payed=false", {}, {}).then(
      ({ data }) => {
        setProducts((cur) => [...cur, ...data.data]);

        if (data?.data?.length < 10) {
          sethasmore(false);
        }
      }
    );
  }

  async function approve() {
    const user = JSON.parse(localStorage.getItem("user"));
    await httpReauest(
      "POST",
      "/order/approve/" + selected,
      {},
      {
        "x-access-token": user.token,
      }
    ).then(({ status }) => {
      if (status === 201) {
        toast.success(
          "فاکتور تایید شد"
        );
        getData();
        setselcted(null)
        setstep(2);
      }
    });
  }

  async function declineOrder() {
    const user = JSON.parse(localStorage.getItem("user"));
    await httpReauest(
      "POST",
      "/order/cancel/" + selected,
      {},
      {
        "x-access-token": user.token,
      }
    ).then(({ status }) => {
      if (status === 201) {
        toast.success(
          "فاکتور رد شد"
        );
        getData();
        setselcted(null)
        setstep(2);
      }
    });
  }

  async function sendOrder() {
    if (!postCode) {
      return toast.error("کد رهگیری خالی است");
    }
    const user = JSON.parse(localStorage.getItem("user"));
    await httpReauest(
      "POST",
      "/order/sended/" + selected._id,
      { postCode },
      {
        "x-access-token": user.token,
      }
    ).then(({ status }) => {
      if (status === 201) {
        toast.success("سفارش تغییر وضعیت به ارسال شده شد");
      }
    });
  }
  return (
    <div>
      <div className="w-full">
        <div className=" mb-10">
          <h1 className="title">فاکتور ها</h1>
        </div>

        <InfiniteScroll
          dataLength={products?.length ? products?.length : 10} //This is important field to render the next data
          next={fetchData}
          hasMore={hasmore}
          loader={"Loading..."}
        >
          {loading ? (
            <Loading />
          ) : (
            <div className="grid gap-3">
              <div className="border p-[12px]  bg-gray-200 duration-200 cursor-pointer">
                <div className="flex justify-between items-center text-[14px] lg:text-[16px]">
                  <span>شماره فاکتور</span>
                  <span>تاریخ</span>
                  <span>وضعیت</span>
                </div>
              </div>
              {products?.map((item) => (
                <div className="border  ">
                  <div
                    onClick={() =>
                      setselcted(selected === item?._id ? null : item?._id)
                    }
                    className="flex justify-between items-center cursor-pointer hover:bg-slate-100 duration-200 p-[12px]  "
                  >
                    <span className=" font-bold text-[14px] lg:text-[18px] flex gap-1 items-center">
                      <FaAngleDown />
                      فاکتور {item?.id}#
                    </span>
                    <span dir="ltr" className="lg:text-[16px] text-[12px]">
                      {new Date(item.createdAt).toLocaleDateString()}
                    </span>
                    {item?.pay_img ? (
                      <span className="font-bold bg-yellow-200 px-3 rounded text-yellow-600 pt-1 lg:text-[16px] text-[12px]">
                        در انتظار تایید
                      </span>
                    ) : item?.status !== "تایید نشده" ? (
                      <span className="font-bold bg-green-200 px-3 rounded text-green-600 pt-1 lg:text-[16px] text-[12px]">
                        پرداخت شده
                      </span>
                    ) : (
                      <span className="font-bold bg-red-200 px-3 rounded text-red-600 pt-1 lg:text-[16px] text-[12px]">
                        پرداخت نشده
                      </span>
                    )}
                  </div>
                  <div
                    className={`${
                      selected === item?._id ? "max-h-[999px]" : "max-h-0"
                    } duration-200 overflow-hidden `}
                  >
                    <div className="grid grid-cols-2  p-[12px] mt-2 lg:text-[16px] text-[14px]">
                      <span className="border-r-2 border-red-500 ps-2 ">
                        تاریخ صورتحساب: <br />{" "}
                        <strong>
                          {new Date(item.createdAt).toLocaleDateString()}
                        </strong>
                      </span>
                      <span className="border-r-2 border-blue-500 ps-2 ">
                        تاریخ سررسید:
                        <br />{" "}
                        <strong>
                          {new Date(item.createdAt).toLocaleDateString()}
                        </strong>
                      </span>
                    </div>
                    <div className="grid lg:grid-cols-2">
                      <div className="mt-3 flex justify-center p-[12px] flex-col items-center">
                        <h5 className="mb-2">مشخصات سفارش</h5>
                        {item?.products?.map((pro) => (
                          <div class="border-b bg-neutral-100 flex justify-between items-center lg:text-[16px] text-[14px]">
                            <td class="whitespace-nowrap px-4 py-2">
                              {pro?.product?.name} {pro?.color} {pro?.storage}{" "}
                              {pro?.count}x
                            </td>
                            <td class="whitespace-nowrap px-4 py-2">
                              {pro?.price}AED
                            </td>
                          </div>
                        ))}

                        <div className="mt-2">
                          <p className=" lg:text-[16px] text-[14px]">
                            فیش پرداختی
                          </p>

                          <Link
                            to={CDN_BASE_URL + item?.pay_img}
                            target="_blank"
                            className="relative"
                          >
                            <img
                              src={CDN_BASE_URL + item?.pay_img}
                              className="w-full max-w-[320px]"
                              alt="payImage"
                            />
                          </Link>

                          <div className="flex justify-center gap-2">
                            <button onClick={approve} className="bg-green-500 text-white px-3 py-1 rounded-[8px] mt-2 hover:bg-green-700 ">
                              تایید فاکتور
                            </button>
                            <button onClick={declineOrder} className="bg-red-500 text-white px-3 py-1 rounded-[8px] mt-2 hover:bg-red-700 ">
                              رد کردن
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="border">
                        {" "}
                        <h5 className="mb-2 text-[20px] bg-slate-700 text-white">مشخصات مشتری</h5>
                        <span className="p-2 flex justify-between flex-wrap gap-3">
                          <span>نام و نام خانوادگی :</span>
                          <span dir="ltr">{item?.name}</span>
                        </span>
                        <span className="p-2 flex justify-between flex-wrap gap-3">
                          <span>شماره تماس:</span>
                          <span dir="ltr">{item?.phone}</span>
                        </span>
                         <span className="p-2 flex justify-between flex-wrap gap-3">
                          <span>ایمیل:</span>
                          <span dir="ltr">{item?.email}</span>
                        </span>
                        <span className="p-2 flex justify-between flex-wrap gap-3">
                          <span>استان:</span>
                          <span dir="ltr">{item?.state}</span>
                        </span>
                        <span className="p-2 flex justify-between flex-wrap gap-3">
                          <span>شهر:</span>
                          <span dir="ltr">{item?.city}</span>
                        </span>{" "}
                        <span className="p-2 flex justify-between flex-wrap gap-3">
                          <span>کد پستی:</span>
                          <span dir="ltr">{item?.postalCode}</span>
                        </span>{" "}
                        <span className="p-2 flex justify-between flex-wrap gap-3">
                          <span>تاریخ سفارش :</span>
                          <span dir="ltr">
                            {" "}
                            {Shamsi.format(
                              "yyyy/MM/dd - hh:mm",
                              new Date(item?.createdAt)
                            )}
                          </span>
                        </span>
                        <span className="p-2 flex">
                          <span>آدرس:</span>
                          <span dir="ltr">{item?.address}</span>
                        </span>{" "}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </InfiniteScroll>
      </div>
    </div>
  );
};

export default BillsPage;
